import { render } from "./SalesForceCallback.vue?vue&type=template&id=2fe48312"
import script from "./SalesForceCallback.vue?vue&type=script&lang=js"
export * from "./SalesForceCallback.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__